// document.querySelectorAll('.bpd').forEach(function (root) {
//   var headings = Array.prototype.slice.call(root.querySelectorAll('.bpd__content h2[id]'));
//   var links = root.querySelectorAll('[data-bpd-toc-link]');

//   if (headings.length && links.length) {
//     var onScroll = function () {
//       var current = headings[0].id;
//       headings.forEach(function (h) {
//         if (window.scrollY >= h.offsetTop - 130) current = h.id;
//       });
//       links.forEach(function (a) {
//         var li = a.closest('li');
//         li.classList.toggle('is-active', a.getAttribute('href') === '#' + current);
//       });
//     };
//     window.addEventListener('scroll', onScroll, { passive: true });
//     onScroll();
//   }

//   var copyBtn = root.querySelector('[data-bpd-copy-link]');
//   if (copyBtn) {
//     copyBtn.addEventListener('click', function () {
//       var url = copyBtn.getAttribute('data-bpd-copy-link');
//       navigator.clipboard && navigator.clipboard.writeText(url);
//     });
//   }

//   // mobile: collapse/expand the Contents list, arrow flips via CSS on .is-open
//   var tocToggle = root.querySelector('[data-bpd-toc-toggle]');
//   var toc = root.querySelector('[data-bpd-toc]');
//   if (tocToggle && toc) {
//     tocToggle.addEventListener('click', function () {
//       var isOpen = toc.classList.toggle('is-open');
//       tocToggle.setAttribute('aria-expanded', isOpen);
//     });
//   }
// });


document.querySelectorAll('.bpd').forEach(function (root) {
  var mobileMq = window.matchMedia('(max-width: 840px)');
  var headings = Array.prototype.slice.call(root.querySelectorAll('.bpd__content h2[id]'));
  var mobileBar = root.querySelector('[data-bpd-mobile-toc-bar]');
  var mobileHost = root.querySelector('[data-bpd-toc-host]');
  var desktopBar = root.querySelector('.bpd__toc-bar--desktop');
  var stickyMetrics = { barTop: 0, barHeight: 0 };

  var getActiveBar = function () {
    return mobileMq.matches ? mobileBar : desktopBar;
  };

  var getTocList = function () {
    var bar = getActiveBar();
    return bar ? bar.querySelector('[data-bpd-toc-list]') : null;
  };

  var getLinks = function () {
    return root.querySelectorAll('[data-bpd-toc-link]');
  };

  var getHeaderHeight = function () {
    var header = document.querySelector('.section-header');
    if (!header) return 60;
    if (header.classList.contains('shopify-section-header-hidden')) return 0;
    return header.offsetHeight;
  };

  var getTocHeight = function () {
    if (!mobileMq.matches || !mobileBar || mobileBar.classList.contains('is-hidden')) return 0;
    return mobileBar.offsetHeight;
  };

  var getSectionBottom = function () {
    return root.getBoundingClientRect().bottom + window.scrollY;
  };

  var setBarHidden = function (hidden) {
    if (!mobileBar) return;
    mobileBar.classList.toggle('is-hidden', hidden);
    if (hidden) {
      mobileBar.classList.remove('is-fixed');
      if (mobileHost) mobileHost.style.minHeight = '';
    }
  };

  var updateScrollOffset = function () {
    root.style.setProperty('--bpd-scroll-offset', (getHeaderHeight() + getTocHeight() + 16) + 'px');
  };

  var getScrollOffset = function () {
    return getHeaderHeight() + getTocHeight() + 16;
  };

  var measureStickyBar = function () {
    if (!mobileBar || !mobileMq.matches) return;

    var wasFixed = mobileBar.classList.contains('is-fixed');
    if (wasFixed) {
      mobileBar.classList.remove('is-fixed');
      if (mobileHost) mobileHost.style.minHeight = '';
    }

    stickyMetrics.barTop = mobileBar.getBoundingClientRect().top + window.scrollY;
    stickyMetrics.barHeight = mobileBar.offsetHeight;

    if (wasFixed) {
      mobileBar.classList.add('is-fixed');
      if (mobileHost) mobileHost.style.minHeight = stickyMetrics.barHeight + 'px';
    }
  };

  var updateStickyBar = function () {
    if (!mobileBar || !mobileMq.matches) {
      setBarHidden(false);
      if (mobileBar) mobileBar.classList.remove('is-fixed');
      if (mobileHost) mobileHost.style.minHeight = '';
      return;
    }

    var headerHeight = getHeaderHeight();
    var scrollY = window.scrollY;
    var sectionBottom = getSectionBottom();
    var pastSection = scrollY + headerHeight + stickyMetrics.barHeight >= sectionBottom;

    if (pastSection) {
      setBarHidden(true);
      return;
    }

    setBarHidden(false);

    var shouldFix = scrollY + headerHeight >= stickyMetrics.barTop;

    mobileBar.style.setProperty('--bpd-toc-fixed-top', headerHeight + 'px');

    if (shouldFix) {
      mobileBar.classList.add('is-fixed');
      if (mobileHost) mobileHost.style.minHeight = stickyMetrics.barHeight + 'px';
    } else {
      mobileBar.classList.remove('is-fixed');
      if (mobileHost) mobileHost.style.minHeight = '';
    }
  };

  var scrollToHeading = function (target) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  var scrollActiveLinkIntoView = function (href) {
    var tocList = getTocList();
    if (!tocList || !mobileMq.matches) return;
    var activeLink = tocList.querySelector('a[href="' + href + '"]');
    if (!activeLink) return;
    var li = activeLink.closest('li');
    if (!li) return;

    var listRect = tocList.getBoundingClientRect();
    var liRect = li.getBoundingClientRect();

    if (liRect.left < listRect.left + 4) {
      tocList.scrollTo({
        left: tocList.scrollLeft + (liRect.left - listRect.left) - 12,
        behavior: 'smooth'
      });
    } else if (liRect.right > listRect.right - 4) {
      tocList.scrollTo({
        left: tocList.scrollLeft + (liRect.right - listRect.right) + 12,
        behavior: 'smooth'
      });
    }
  };

  var onLayoutChange = function () {
    measureStickyBar();
    updateStickyBar();
    updateScrollOffset();
  };

  onLayoutChange();
  window.addEventListener('resize', onLayoutChange);
  window.addEventListener('load', onLayoutChange);
  if (typeof mobileMq.addEventListener === 'function') {
    mobileMq.addEventListener('change', onLayoutChange);
  } else if (typeof mobileMq.addListener === 'function') {
    mobileMq.addListener(onLayoutChange);
  }

  var links = getLinks();

  if (headings.length && links.length) {
    var activeHref = '';

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        scrollToHeading(target);
        if (history.replaceState) {
          history.replaceState(null, '', '#' + id);
        } else {
          location.hash = id;
        }
      });
    });

    var onScroll = function () {
      updateStickyBar();
      updateScrollOffset();

      var offset = getScrollOffset();
      var current = headings[0].id;
      headings.forEach(function (h) {
        var top = h.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY >= top - offset) current = h.id;
      });

      var currentHref = '#' + current;
      links.forEach(function (a) {
        var li = a.closest('li');
        if (!li) return;
        li.classList.toggle('is-active', a.getAttribute('href') === currentHref);
      });

      if (mobileMq.matches && currentHref !== activeHref) {
        scrollActiveLinkIntoView(currentHref);
      }
      activeHref = currentHref;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  } else {
    window.addEventListener('scroll', function () {
      updateStickyBar();
      updateScrollOffset();
    }, { passive: true });
  }

  var copyBtn = root.querySelector('[data-bpd-copy-link]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-bpd-copy-link');
      navigator.clipboard && navigator.clipboard.writeText(url);
    });
  }

  var tocToggle = desktopBar && desktopBar.querySelector('[data-bpd-toc-toggle]');
  var desktopToc = desktopBar && desktopBar.querySelector('[data-bpd-toc]');
  if (tocToggle && desktopToc && !mobileMq.matches) {
    tocToggle.addEventListener('click', function () {
      var isOpen = desktopToc.classList.toggle('is-open');
      tocToggle.setAttribute('aria-expanded', isOpen);
    });
  }
});
